import { primaryKey, headerCode, inputType, required, length, order, pattern, editable, Describer, visible, GceEntity, relation, currency } from './gce-management';
import { GceInvoicePerson } from './gce-invoice-person';
import { GceClinic } from './gce-clinic';

/**
 * GceInvoice -> table: medici_fatturazione_compensi_dms
 */
export class GceInvoicePersonCompensationDMS extends GceEntity {
    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.IDFATTURAZIONE')
    @inputType('hidden')
    @order(1)
    idfatturazione: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.DATA_INZIO')
    @inputType('date')
    @order(2)
    data_inzio: Date | string;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.DATA_FINE')
    @inputType('date')
    @order(3)
    data_fine: Date | string;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.ID_AREA')
    @inputType('select')
    @length(16)
    @relation("GceArea", {columnRel:'AreaId', columnDescr:['AreaDescrizione']})
    @required()
    @order(4)
    idarea: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.FISSO_MENSILE')
    @inputType('number')
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(5)
    fisso_mensile: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.BONUS_MENSILE_PRODUZIONE_AREA')
    @inputType('number')
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(6)
    bonus_mensile_produzione_area: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.VARIABILE_MENSILE_PRODUZIONE_PERSONALE')
    @inputType('number')
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(7)
    variabile_mensile_produzione_personale: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.EXTRA_BONUS_TRIMESTRALE')
    @inputType('number')
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(8)
    extra_bonus_trimestrale: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.VARIABILE_TRIMESTRALE_FATTURATO_AREA')
    @inputType('number')
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(9)
    variabile_trimestrale_fatturato_area: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.VARIABILE_TRIMESTRALE_VECCHIO_PRODUZIONE_AREA')
    @inputType('number')
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(10)
    variabile_trimestrale_vecchio_produzione_area: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.GG_LAVORO_MESE')
    @inputType('number')
    @pattern('00')
    @order(11)
    gg_lavoro_mese:number;
    
    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.GG_FERIE_ANNO')
    @inputType('number')
    @pattern('00')
    @order(12)
    gg_ferie_anno:number;
   

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.DATA_INIZIO_CALCOLO_FERIE')
    @inputType('date')
    @order(13)
    data_inizio_calcolo_ferie: Date | string;
    
    
    constructor();
    constructor(idfatturazione: number, data_inzio: Date | string, data_fine: Date | string, idarea: number,  fisso_mensile: number,  bonus_mensile_produzione_area: number,  variabile_mensile_produzione_personale: number,  extra_bonus_trimestrale: number,  variabile_trimestrale_fatturato_area: number,  variabile_trimestrale_vecchio_produzione_area: number,  gg_lavoro_mese:number, gg_ferie_anno:number,data_inizio_calcolo_ferie: Date | string);
    constructor(idfatturazione?: number,data_inzio?: Date | string, data_fine?: Date | string, idarea?: number,  fisso_mensile?: number,  bonus_mensile_produzione_area?: number,  variabile_mensile_produzione_personale?: number,  extra_bonus_trimestrale?: number,  variabile_trimestrale_fatturato_area?: number,  variabile_trimestrale_vecchio_produzione_area?: number,  gg_lavoro_mese?:number, gg_ferie_anno?:number,data_inizio_calcolo_ferie?: Date | string){
        super();
        this.idfatturazione = idfatturazione;
        this.data_inzio = data_inzio;
        this.data_fine = data_fine;
        this.idarea=idarea;  
        this.fisso_mensile=fisso_mensile;
        this.bonus_mensile_produzione_area=bonus_mensile_produzione_area;
        this.variabile_mensile_produzione_personale=variabile_mensile_produzione_personale;
        this.extra_bonus_trimestrale=extra_bonus_trimestrale;
        this.variabile_trimestrale_fatturato_area=variabile_trimestrale_fatturato_area;
        this.variabile_trimestrale_vecchio_produzione_area=variabile_trimestrale_vecchio_produzione_area;
        this.gg_lavoro_mese=gg_lavoro_mese;
        this.gg_ferie_anno=gg_ferie_anno;
        this.data_inizio_calcolo_ferie=data_inizio_calcolo_ferie;
    }

    static getStructure():Array<any>{
        let structure:any[] = Describer.getStructure(new GceInvoicePersonCompensationDMS());
        structure.push(...this.getActions());
        return structure;
    }
    protected static getActions():any[]{
        let actions:any[] = [];
        return actions;
    }

    static parse(data:any):GceInvoicePersonCompensationDMS{
        let gipc = new GceInvoicePersonCompensationDMS(
            data['IDFATTURAZIONE'],
            data['DATA_INZIO'],
            data['DATA_FINE'],
            data['IDAREA'],
            data['FISSO_MENSILE'],
            data['BONUS_MENSILE_PRODUZIONE_AREA'],
            data['VARIABILE_MENSILE_PRODUZIONE_PERSONALE'],
            data['EXTRA_BONUS_TRIMESTRALE'],
            data['VARIABILE_TRIMESTRALE_FATTURATO_AREA'],
            data['VARIABILE_TRIMESTRALE_VECCHIO_PRODUZIONE_AREA'],
            data['GG_LAVORO_MESE'],
            data['GG_FERIE_ANNO'],
            data['DATA_INIZIO_CALCOLO_FERIE']
        );
        return gipc;
    }
    
}
